<template>
  <div class="text-page">
    <div class="inner-page" :class="{'app-center': centered}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextPage",
  props: {
    centered: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
div.text-page {
  div.inner-page {
    p,
    ul {
      margin-top: 16px;

      &.no-margin {
        margin-top: 0;
      }
    }
  }
}
</style>
